<script lang="ts">
	import Card from '$lib/components/Card.svelte';
	import type { OperationSummaryModel } from '@app/models/api/OperationSummaryModel';
	import { urls } from '@app/urls';
	import { t } from 'svelte-i18n';
	import Icon from '$lib/elements/Icon.svelte';
	import FollowProject from '../FollowProject.svelte';
	import CardReturnAndTaxReliefBlock from './CardReturnAndTaxReliefBlock.svelte';
	import FundedAndRefundedCardBody from './FundedAndRefundedCardBody.svelte';
	import { page } from '$app/stores';

	export let props: OperationSummaryModel;
</script>

<Card
	sector={props.category}
	title={props.projectName}
	mediaUrl={props.projectShortImageCardURL
		? props.projectShortImageCardURL
		: props.projectShortCoverImageURL}
	desc={props.projectShortDescriptionFr}
	isConfidential={props.isConfidential}
	isPremiumOnly={props.isPremiumOnly}
	isPrivateAccess={props.isPrivateAccess}
	href={!props.isConfidential && props.id ? urls.PROJECT.INDEX(props.id.toString(10)) : urls.HOME}
	isLoggedIn={!!$page.data.user}
>
	<div slot="status" class="flex justify-between items-center">
		<div class="text-success flex justify-between items-center space-x-2">
			<Icon name="check" size="small" />
			<span class="font-semibold text-sm">
				{#if props.projectNbAssociates}
					{$t('operation.messages.fundedByXWiSEEDers', {
						values: { nb: props.projectNbAssociates }
					})}
				{:else}
					{$t('funded')}
				{/if}
			</span>
		</div>
		<div class="text-primary">
			<FollowProject operationId={props.id.toString()} follows={props.follows} />
		</div>
	</div>
	<div slot="body">
		<FundedAndRefundedCardBody {props} />
	</div>
	<div slot="footer">
		<div class="flex items-center space-x-3">
			{#if props.percentageYieldBond || props.isPaymentTransferPEA || props.isTaxReliefISF || props.isTaxReliefIRPP || props.isTaxReliefIntakeDisposal}
				<CardReturnAndTaxReliefBlock {props} />
			{/if}
		</div>
	</div>
</Card>
